module.exports = __webpack_public_path__ + "img/b46e6c4.jpg";